import { FlexBox, Text } from '@fable/components'
import { css, useTheme } from '@fable/theme'
import { useQuery } from 'react-query'
import { get } from '@fable/api'
import { MLPClubsCarousel } from './MLPClubsCarousel'

export const MLPClubsBanner = () => {
  const { colors, mediaQueries } = useTheme()

  const { data, isLoading } = useQuery(['popular_club'], () =>
    get('/popular_clubs')
  )

  const popularClubs = data?.data || []
  if (isLoading || !popularClubs?.length) return null

  return (
    <div className="fade">
      <FlexBox flexDirection="column" centerAll>
        <Text
          tag="h2"
          type="header"
          color={colors.uiGraphite}
          align="center"
          custom={{
            fontSize: '56px',
            lineHeight: '52px',
            letterSpacing: '-4px',
            [mediaQueries.mobileL]: {
              fontSize: '100px',
              lineHeight: '100px',
              letterSpacing: '-2px',
            },
          }}
        >
          Join readers in
        </Text>
        <Text
          tag="h2"
          className={css`
            margin-top: -14px;
            text-shadow: ${colors.uiPearlExtraLight} -1px 1px 0px,
              ${colors.uiPearlExtraLight} 1px 1px 0px,
              ${colors.uiPearlExtraLight} 1px -1px 0px,
              ${colors.uiPearlExtraLight} -1px -1px 0px;
            ${mediaQueries.mobileL} {
              margin-top: -30px;
              text-shadow: ${colors.uiPearlExtraLight} -2px 2px 0px,
                ${colors.uiPearlExtraLight} 2px 2px 0px,
                ${colors.uiPearlExtraLight} 2px -2px 0px,
                ${colors.uiPearlExtraLight} -2px -2px 0px;
            }
          `}
          type="script"
          color={colors.uiPink}
          align="center"
          custom={{
            fontSize: '44px',
            lineHeight: '44px',
            letterSpacing: '-0.5px',
            [mediaQueries.mobileL]: {
              fontSize: '84px',
              lineHeight: '82px',
            },
          }}
        >
          10,000+ book clubs
        </Text>
      </FlexBox>
      <MLPClubsCarousel clubs={popularClubs} />
    </div>
  )
}
